import { render } from "./PartnerEdit.vue?vue&type=template&id=3f1d8714&scoped=true"
import script from "./PartnerEdit.vue?vue&type=script&lang=js"
export * from "./PartnerEdit.vue?vue&type=script&lang=js"

import "./PartnerEdit.vue?vue&type=style&index=0&id=3f1d8714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d8714"]])

export default __exports__